module.exports = __webpack_public_path__ + "img/skill-dive.a5af4acb.png";